import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { countryCodes } from '@/util/constants';
import { getCountry } from '@/util/constants';
import { ensureHostInfo, resetHostLoad } from '../services/host';

export const useHost = () => {
    const queryClient = useQueryClient();
    const hostname = window.location.hostname.toLowerCase();

    const { data, isLoading, isError } = useQuery({
        queryKey: ['host', hostname],
        queryFn: () => ensureHostInfo(),
        throwOnError: false,
        staleTime: 60 * 60 * 1000, // 1 hour — host/brand config changes infrequently
        gcTime: 2 * 60 * 60 * 1000 // 2 hours
    });

    const refetch = useCallback(() => {
        resetHostLoad();
        queryClient.invalidateQueries({ queryKey: ['host', hostname] });
    }, [queryClient, hostname]);

    const brandLocale = useMemo(() => {
        const country = data?.country;
        const countryCode = getCountry(country);
        const locale = countryCodes[countryCode];
        return locale;
    }, [data?.country]);

    return { data, isLoading, isError, refetch, brandLocale };
};
